import { createElement } from '../../../core/dom/helpers.js';

/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const numberDriver = {
  type: 'number',
  mount(container, ctx) {
    const { def, onChange } = ctx;
    const numberDef = /** @type {import('../../../contracts/forms.js').NumberFieldDef} */ (def);

    /** @type {Record<string, string>} */
    const attrs = {
      type: 'number',
      id: `field-${def.key}`,
      name: def.key,
      class: 'form-field-input',
    };
    if (numberDef.min != null) attrs.min = String(numberDef.min);
    if (numberDef.max != null) attrs.max = String(numberDef.max);
    if (numberDef.step != null) attrs.step = String(numberDef.step);
    if (def.placeholder) attrs.placeholder = def.placeholder;
    if (def.required) { attrs.required = 'required'; attrs['aria-required'] = 'true'; }
    if (def.disabled) attrs.disabled = 'disabled';

    const input = /** @type {HTMLInputElement} */ (createElement('input', attrs));
    container.appendChild(input);

    if (ctx.value !== undefined && ctx.value !== null) {
      input.value = String(ctx.value);
    }

    input.addEventListener('input', () => onChange(input.value === '' ? null : Number(input.value)));

    return {
      setValue(value) {
        input.value = value == null ? '' : String(value);
      },
      getValue() {
        return input.value === '' ? null : Number(input.value);
      },
      setErrors() {
        // errors rendered by host
      },
      destroy() {
        input.remove();
      },
      setDisabled(disabled) {
        input.disabled = disabled;
      },
      clearValue() {
        input.value = '';
      },
      setAriaInvalid(invalid) {
        input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      },
    };
  },
};
